<template>
  <div class="block">
    <h4 style="color: #555; padding-left: 2rem;">New Genome Release</h4>
    <el-timeline>
      <el-timeline-item v-for="(item, index) in releaseData.slice(0,4)" :key="index" :timestamp="item.date"
      icon="el-icon-check" color="#22B14C" placement="top">
        <release-card :item="item"></release-card>
      </el-timeline-item>
      <el-timeline-item timestamp="... Reading more" placement="top">
        <el-badge :value="releaseData.length" class="mt-2">
          <el-button @click="drawer=true" style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
            Show All
          </el-button>
        </el-badge>
      </el-timeline-item>
    </el-timeline>
    <el-drawer title="Release Note" :visible.sync="drawer" direction="rtl" size="40%" :modal="false">
      <el-timeline>
        <el-timeline-item v-for="(item, index) in visibleReleaseData" :key="index" :timestamp="item.date"
        icon="el-icon-check" color="#22B14C" placement="top">
          <release-card :item="item"></release-card>
        </el-timeline-item>
        <el-timeline-item v-if="visibleReleaseData.length < releaseData.length" timestamp="... Load more" placement="top">
          <el-badge :value="releaseData.length - visibleReleaseData.length" class="mt-2">
            <el-button @click="loadMore" :loading="loading" style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
              Load More
            </el-button>
          </el-badge>
        </el-timeline-item>
      </el-timeline>
    </el-drawer>
  </div>
</template>

<script>
import { getRecentRelease } from '@/api/api'
import ReleaseCard from './ReleaseCard.vue'
export default {
  components: { ReleaseCard },
  data() {
    return {
      releaseData: [],
      visibleReleaseData: [],
      drawer: false,
      loading: false,
      itemsToShow: 10 // 初始显示的项目数
    }
  },
  created() {
    this.getHbRecentRelease()
  },
  methods: {
    getHbRecentRelease() {
      getRecentRelease().then(
        response => {
          this.releaseData = response.data
          this.visibleReleaseData = this.releaseData.slice(0, this.itemsToShow)
        }
      )
    },
    loadMore() {
      if (this.visibleReleaseData.length < this.releaseData.length) {
        this.loading = true;
        setTimeout(() => {
          this.itemsToShow += 10;
          this.visibleReleaseData = this.releaseData.slice(0, this.itemsToShow)
          this.loading = false;
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss">
</style>
